var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitOfMeasurementIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2709_26438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5562 4.43563L13.997 2.99479C14.0376 2.95422 14.0699 2.90602 14.0919 2.85297C14.1139 2.79992 14.1252 2.74306 14.1252 2.68563C14.1252 2.6282 14.1139 2.57134 14.0919 2.51828C14.0699 2.46523 14.0376 2.41704 13.997 2.37646L12.6206 1",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 14.0606V3.56063C2.75 3.32857 2.84219 3.106 3.00628 2.94191C3.17037 2.77782 3.39294 2.68563 3.625 2.68563C3.625 2.68563 10.3223 2.68563 13.9792 2.68563",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.492L2.44083 13.9323C2.48146 13.973 2.5297 14.0052 2.58281 14.0272C2.6359 14.0492 2.69282 14.0605 2.75029 14.0605C2.80777 14.0605 2.86468 14.0492 2.91778 14.0272C2.97088 14.0052 3.01912 13.973 3.05975 13.9323L4.5 12.4915",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 14.0606C13.482 14.0606 13.7046 13.9685 13.8687 13.8044C14.0328 13.6403 14.125 13.4177 14.125 13.1856",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.0606H10.625",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 14.0606H8",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 14.0606H5.375",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 11.4356V10.5606",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 8.81063V7.93563",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 6.18563V5.31063",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2709_26438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitOfMeasurementIcon);
export default __webpack_public_path__ + "static/media/UnitOfMeasurementIcon.225fa7e3ec59092bc880e418fa07b597.svg";
export { ForwardRef as ReactComponent };